export default __webpack_public_path__ + "static/giotto-plus-1-983cc1238498e88c0bd7ce9654b26c37.jpg";